/* ═══════════════════════════════════════════════════════════════════
   REVIEWS PAGE — Three layouts driven from one reviews.json
   In production: remove the EMBEDDED_DATA fallback and the demo switcher.
   ═══════════════════════════════════════════════════════════════════ */

/* ── State ── */
let DATA = { products: [], reviews: [] };
let activeFilter = 'all';     // product slug or 'all'
const REVIEWS_PER_PAGE = 10;
let visibleReviewCount = REVIEWS_PER_PAGE;
const ALL_REVIEWS_FEATURED_SLUG = 'terror-tarot-deck';

/* ── Shopify live product data merge ──
   The JSON keeps review grouping stable. Shopify can override image, link, price, and handle
   from section product pickers without changing the review data file. */
function normalizeProductKey(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function applyShopifyProductData() {
  const bySlugOrHandle = window.SHOPIFY_PRODUCT_DATA || {};
  const byName = window.SHOPIFY_PRODUCT_DATA_BY_NAME || {};
  const byIndex = window.SHOPIFY_PRODUCT_DATA_BY_INDEX || [];

  DATA.products.forEach((product, index) => {
    const live =
      bySlugOrHandle[product.slug] ||
      bySlugOrHandle[product.handle] ||
      byName[normalizeProductKey(product.name)] ||
      byIndex[index];

    if (live) {
      Object.assign(product, live);
      if (live.variantRequested && !live.variantMatched) {
        console.warn('[GG Reviews] Variant mapping did not find a matching variant. Falling back to the parent product.', {
          reviewProduct: product.name,
          slug: product.slug,
          handle: live.handle,
          live
        });
      }
      if (live.variantMatched && live.imageSource === 'product_featured_image') {
        console.warn('[GG Reviews] Variant was matched, but no variant-specific image was found. Falling back to the parent product image. Assign an image to this Shopify variant or use the Image override field in the mapping block.', {
          reviewProduct: product.name,
          slug: product.slug,
          handle: live.handle,
          variantTitle: live.variantTitle,
          variantId: live.variantId,
          live
        });
      }
    }
  });
}


/* ── Placeholder SVG art per product (used when image is null in JSON) ──
   In production with real product photos, you'll use <img src> instead. */
const PLACEHOLDER_ART = {
  "hecates-wheel": `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(100,100)" fill="none" stroke="#E8841C" stroke-width="2" stroke-linecap="round">
      <circle r="70" stroke-width="1.5"/><circle r="48" stroke-width="1" stroke-opacity="0.5"/>
      <g><path d="M0,-40 Q-12,-30 -12,-15 Q-12,0 0,0 M0,-40 Q12,-30 12,-15 Q12,0 0,0"/></g>
      <g transform="rotate(120)"><path d="M0,-40 Q-12,-30 -12,-15 Q-12,0 0,0 M0,-40 Q12,-30 12,-15 Q12,0 0,0"/></g>
      <g transform="rotate(240)"><path d="M0,-40 Q-12,-30 -12,-15 Q-12,0 0,0 M0,-40 Q12,-30 12,-15 Q12,0 0,0"/></g>
      <circle r="4" fill="#E8841C" stroke="none"/>
    </g></svg>`,
  "the-exercist": `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(100,110)" fill="none" stroke="#E8841C" stroke-width="2" stroke-linecap="round">
      <line x1="-58" y1="0" x2="58" y2="0" stroke-width="4"/>
      <rect x="-68" y="-14" width="16" height="28" rx="2" fill="#E8841C"/>
      <rect x="52" y="-14" width="16" height="28" rx="2" fill="#E8841C"/>
      <g transform="translate(0, -32)">
        <ellipse rx="22" ry="24" fill="#1a1520" stroke="#F2EEE8" stroke-width="1.8"/>
        <circle cx="-7" cy="-3" r="4" fill="#F2EEE8"/><circle cx="7" cy="-3" r="4" fill="#F2EEE8"/>
        <path d="M-5,12 Q0,16 5,12" stroke="#F2EEE8" stroke-width="1.8"/>
      </g></g></svg>`,
  "how-to-summon-me": `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(100,100)" fill="none" stroke="#E8841C" stroke-width="1.8" stroke-linecap="round">
      <rect x="-50" y="-55" width="100" height="110" rx="3" stroke-opacity="0.6"/>
      <line x1="-38" y1="-32" x2="38" y2="-32"/><line x1="-38" y1="-18" x2="20" y2="-18"/>
      <line x1="-38" y1="-2" x2="38" y2="-2"/><line x1="-38" y1="12" x2="28" y2="12"/>
      <line x1="-38" y1="26" x2="36" y2="26"/><line x1="-38" y1="40" x2="22" y2="40"/>
      <text x="0" y="-42" text-anchor="middle" font-family="UnifrakturMaguntia" font-size="11" fill="#E8841C" stroke="none">How To Summon</text>
    </g></svg>`,
  "black-magick": `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    <circle cx="100" cy="70" r="32" fill="none" stroke="#E8841C" stroke-width="1.5" opacity="0.7"/>
    <g transform="translate(100,120)" fill="#1a1520" stroke="#E8841C" stroke-width="2">
      <ellipse cx="0" cy="0" rx="32" ry="28"/>
      <path d="M-25,-22 L-30,-38 L-18,-26 Z" fill="#E8841C"/>
      <path d="M25,-22 L30,-38 L18,-26 Z" fill="#E8841C"/>
      <circle cx="-12" cy="-4" r="3" fill="#E8841C"/><circle cx="12" cy="-4" r="3" fill="#E8841C"/>
      <path d="M-3,8 Q0,12 3,8" fill="none" stroke-width="1.5"/>
      <path d="M14,-2 Q40,-8 50,4 M14,2 Q40,4 50,12 M-14,-2 Q-40,-8 -50,4 M-14,2 Q-40,4 -50,12" fill="none" stroke-width="1.2"/>
    </g></svg>`,
  "nevermore": `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(100,100)" fill="#1a1520" stroke="#E8841C" stroke-width="1.8" stroke-linecap="round">
      <path d="M-40,10 Q-30,-30 0,-30 Q30,-30 40,10 Q35,30 20,40 Q0,45 -20,40 Q-35,30 -40,10 Z"/>
      <path d="M-10,-25 L-25,-50 L-5,-30 Z" fill="#E8841C"/>
      <circle cx="-8" cy="-5" r="3" fill="#E8841C"/>
      <path d="M15,15 L45,25 L40,20 L52,30" fill="none" stroke-width="1.5"/>
      <path d="M-15,40 L-12,55 M-5,42 L-2,58 M5,42 L8,58" stroke-width="1.2"/>
    </g></svg>`,
  "witchs-brew": `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(100,115)" fill="none" stroke="#E8841C" stroke-width="2" stroke-linecap="round">
      <path d="M-50,0 Q-50,50 0,52 Q50,50 50,0 Z" fill="#1a1520"/>
      <ellipse cx="0" cy="0" rx="50" ry="10" fill="#241828"/>
      <ellipse cx="0" cy="0" rx="50" ry="10" stroke-width="2"/>
      <path d="M-30,-10 Q-25,-30 -20,-15 Q-15,-35 -10,-15 Q-5,-40 0,-20 Q5,-35 10,-15 Q15,-30 20,-12 Q25,-28 30,-10" stroke-opacity="0.7" stroke-width="1.5"/>
      <circle cx="-15" cy="3" r="2" fill="#E8841C"/><circle cx="10" cy="5" r="2" fill="#E8841C"/>
    </g></svg>`,
  "just-hangin": `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    <line x1="40" y1="50" x2="160" y2="50" stroke="#E8841C" stroke-width="1.5" opacity="0.5"/>
    <g transform="translate(100,90)" fill="#1a1520" stroke="#E8841C" stroke-width="1.8">
      <path d="M0,-40 L-5,-35 L-3,-32 Q-5,-30 -8,-28 L-3,-25 Q-10,-15 -25,-10 Q-45,-5 -55,5 Q-45,5 -38,2 Q-32,8 -30,18 L-25,12 Q-15,20 -10,25 L-8,18 L-5,22 L-3,15 L0,20 L3,15 L5,22 L8,18 L10,25 Q15,20 25,12 L30,18 Q32,8 38,2 Q45,5 55,5 Q45,-5 25,-10 Q10,-15 3,-25 L8,-28 Q5,-30 3,-32 L5,-35 Z"/>
      <circle cx="-10" cy="-22" r="2" fill="#E8841C"/><circle cx="10" cy="-22" r="2" fill="#E8841C"/>
    </g></svg>`,
  "stay-weird": `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(100,100)" fill="none" stroke="#E8841C" stroke-width="2" stroke-linecap="round">
      <path d="M-50,0 Q-25,-30 0,-30 Q25,-30 50,0 Q25,30 0,30 Q-25,30 -50,0 Z"/>
      <circle cx="0" cy="0" r="18" fill="#1a1520"/>
      <circle cx="0" cy="0" r="18"/>
      <circle cx="0" cy="0" r="9" fill="#E8841C"/>
      <circle cx="0" cy="0" r="4" fill="#1a1520"/>
      <text x="0" y="55" text-anchor="middle" font-family="UnifrakturMaguntia" font-size="14" fill="#E8841C" stroke="none">Stay Weird</text>
    </g></svg>`
};

/* ── Utilities ── */
function getProductBySlug(slug) {
  return DATA.products.find(p => p.slug === slug);
}
function renderStars(rating) {
  const numeric = Number(rating) || 0;
  const display = Math.max(0, Math.min(5, Math.round(numeric)));
  const full = '★'.repeat(display);
  const empty = '☆'.repeat(5 - display);
  return `<span aria-label="${numeric.toFixed(1)} out of 5 stars">${full}${empty}</span>`;
}
function formatDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
}

function joinMeta(parts) {
  return parts.filter(Boolean).map(escapeHtml).join(' · ');
}
function isPlatformValue(value) {
  return /^(etsy|amazon)$/i.test(String(value || '').trim());
}
function cleanCustomerLocation(value) {
  return isPlatformValue(value) ? '' : String(value || '').trim();
}
function reviewSourceLabel(review) {
  // Platform names are intentionally not surfaced on the customer-facing page.
  return '';
}

function productLink(product) {
  return product && product.link ? product.link : '#';
}

function productArt(product) {
  // If JSON provides an image URL, use it. Otherwise fall back to SVG placeholder.
  if (product.image) {
    return `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.name)}" loading="lazy">`;
  }
  return PLACEHOLDER_ART[product.slug] || PLACEHOLDER_ART['stay-weird'];
}

/* ── Filtering ── */
function getFilteredReviews() {
  let list = DATA.reviews.slice();
  if (activeFilter !== 'all') {
    list = list.filter(r => r.productSlug === activeFilter);
  }
  // Keep the spreadsheet/JSON order. The review file is already sorted by
  // praiseworthiness, detail, and contextual relevance. Do not re-sort by date.
  return list;
}

function pickFeaturedReview(list) {
  if (!list.length) return null;

  if (activeFilter === 'all') {
    return list.find(r => r.productSlug === ALL_REVIEWS_FEATURED_SLUG && r.featured) ||
      list.find(r => r.productSlug === ALL_REVIEWS_FEATURED_SLUG) ||
      list[0];
  }

  return list.find(r => r.featured) || list[0];
}

/* ── Stats in hero ── */
function renderHeroStats() {
  const all = DATA.reviews;
  if (!all.length) return;
  const avg = (all.reduce((s,r) => s + r.rating, 0) / all.length).toFixed(1);
  const verified = all.filter(r => r.verified).length;
  document.getElementById('stat-total').textContent = all.length.toLocaleString();
  document.getElementById('stat-avg').textContent = avg;
  document.getElementById('stat-verified').textContent = verified.toLocaleString();
}

/* ── Filter pills ── */
function renderFilterPills() {
  const container = document.getElementById('filter-pills');
  const total = DATA.reviews.length;
  let html = `<button class="f-pill ${activeFilter === 'all' ? 'active' : ''}" data-filter="all"><span class="f-thumb f-thumb-all"></span><span class="f-name">All Reviews</span><span class="count">${total}</span></button>`;
  DATA.products.forEach(p => {
    const count = DATA.reviews.filter(r => r.productSlug === p.slug).length;
    if (count === 0) return;
    html += `<button class="f-pill ${activeFilter === p.slug ? 'active' : ''}" data-filter="${p.slug}"><span class="f-thumb">${productArt(p)}</span><span class="f-name">${escapeHtml(p.name)}</span><span class="count">${count}</span></button>`;
  });
  container.innerHTML = html;
  container.querySelectorAll('.f-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      activeFilter = pill.dataset.filter;
      visibleReviewCount = REVIEWS_PER_PAGE;
      // Keep the clicked pill in view after re-render
      const clickedSlug = pill.dataset.filter;
      renderAll();
      requestAnimationFrame(() => {
        const newPill = container.querySelector(`.f-pill[data-filter="${clickedSlug}"]`);
        if (newPill) newPill.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      });
    });
  });
  // After painting, evaluate whether fades should be shown
  requestAnimationFrame(updateFilterFade);
}

/* ── Fade edge indicators on the filter scroll strip ── */
function updateFilterFade() {
  const wrap  = document.getElementById('filter-pills-wrap');
  const pills = document.getElementById('filter-pills');
  if (!wrap || !pills) return;
  const overflows        = pills.scrollWidth > pills.clientWidth + 1;
  const scrolledFromLeft = pills.scrollLeft > 4;
  const scrolledToRight  = pills.scrollLeft + pills.clientWidth >= pills.scrollWidth - 4;
  wrap.classList.toggle('has-overflow-left',  overflows && scrolledFromLeft);
  wrap.classList.toggle('has-overflow-right', overflows && !scrolledToRight);
  // Keep the arrow button visual state in sync with scroll position
  updateScrollBtn();
}
// Re-check on scroll + resize
window.addEventListener('resize', updateFilterFade);
document.addEventListener('DOMContentLoaded', () => {
  const pills = document.getElementById('filter-pills');
  if (pills) pills.addEventListener('scroll', updateFilterFade, { passive: true });
});

/* ── Results meta ── */
function renderMeta() {
  const list = getFilteredReviews();
  const shown = Math.min(visibleReviewCount, list.length);
  document.getElementById('results-count').textContent = `${shown.toLocaleString()} of ${list.length.toLocaleString()}`;
  const label = activeFilter === 'all'
    ? 'All products'
    : `Filtered: ${getProductBySlug(activeFilter)?.name || activeFilter}`;
  document.getElementById('filter-label').textContent = label;
}

/* ═══════════════════════════ REVIEWS RENDER ═══════════════════════════ */
function renderReviews() {
  const list = getFilteredReviews();
  const container = document.getElementById('reviews-content');

  if (!list.length) {
    container.innerHTML = `<div class="rv-empty">No reviews yet for this product. Be the first to cast your verdict.</div>`;
    return;
  }

  const featured = pickFeaturedReview(list);
  const ordered = [featured, ...list.filter(r => r.id !== featured.id)];
  const visibleReviews = ordered.slice(0, visibleReviewCount);
  const rest = visibleReviews.filter(r => r.id !== featured.id);

  const fp = getProductBySlug(featured.productSlug);
  let html = `
    <div class="rv-featured">
      <a href="${escapeHtml(productLink(fp))}" class="rv-featured-art" aria-label="Shop ${escapeHtml(fp.name)}">
        <span class="rv-featured-badge">★ Featured Review</span>
        ${productArt(fp)}
      </a>
      <div class="rv-featured-body">
        <p class="rv-featured-eyebrow">${escapeHtml(fp.category)} · ${escapeHtml(fp.name)}</p>
        <div class="rv-featured-stars">${renderStars(featured.rating)}</div>
        <h2 class="rv-featured-title">${escapeHtml(featured.title)}</h2>
        <p class="rv-featured-quote">${escapeHtml(featured.body)}</p>
        <div class="rv-featured-sig">
          <div>
            <p class="rv-featured-sig-name">${escapeHtml(featured.reviewer)} ${featured.verified ? '<span class="rv-verified">◆ Verified</span>' : ''}</p>
            <p class="rv-featured-sig-meta">${joinMeta([cleanCustomerLocation(featured.location), formatDate(featured.date), featured.garment])}</p>
          </div>
        </div>
        <a href="${escapeHtml(productLink(fp))}" class="rv-product-link">Shop ${escapeHtml(fp.name)}</a>
      </div>
    </div>`;

  html += `<div class="rv-editorial-grid">`;
  rest.forEach(r => {
    const p = getProductBySlug(r.productSlug);
    if (!p) return;
    html += `
      <article class="rv-ed-card">
        <a href="${escapeHtml(productLink(p))}" class="rv-ed-art" aria-label="Shop ${escapeHtml(p.name)}">
          ${productArt(p)}
          <span class="rv-ed-art-link"><span>Shop This Item →</span></span>
        </a>
        <div class="rv-ed-body">
          <div>
            <div class="rv-ed-top">
              <p class="rv-ed-product"><a href="${escapeHtml(productLink(p))}">${escapeHtml(p.name)} · ${escapeHtml(p.category)}</a></p>
              <span class="rv-ed-stars">${renderStars(r.rating)}</span>
            </div>
            <h3 class="rv-ed-title">${escapeHtml(r.title)}</h3>
            <p class="rv-ed-body-text">${escapeHtml(r.body)}</p>
          </div>
          <div class="rv-ed-footer">
            <span class="rv-ed-reviewer">${escapeHtml(r.reviewer)} ${r.verified ? '<span class="rv-verified">◆</span>' : ''}${cleanCustomerLocation(r.location) ? ` <span class="rv-ed-reviewer-loc">· ${escapeHtml(cleanCustomerLocation(r.location))}</span>` : ''}</span>
            <span class="rv-ed-meta">${joinMeta([formatDate(r.date), r.garment])}</span>
          </div>
        </div>
      </article>`;
  });
  html += `</div>`;

  if (visibleReviewCount < list.length) {
    const remaining = list.length - visibleReviewCount;
    const nextCount = Math.min(REVIEWS_PER_PAGE, remaining);
    html += `
      <div class="rv-load-more-wrap">
        <button class="rv-load-more" type="button" id="rv-load-more">Load ${nextCount} More Reviews</button>
        <p class="rv-load-more-meta">${visibleReviewCount.toLocaleString()} of ${list.length.toLocaleString()} shown</p>
      </div>`;
  }

  container.innerHTML = html;

  const loadMore = document.getElementById('rv-load-more');
  if (loadMore) {
    loadMore.addEventListener('click', () => {
      visibleReviewCount += REVIEWS_PER_PAGE;
      renderMeta();
      renderReviews();
    });
  }
}

/* ── Master render ── */
function renderAll() {
  renderFilterPills();
  renderMeta();
  renderReviews();
}

/* ── Filter strip horizontal-scroll arrow buttons (left + right) ──
   Each button scrolls the pill strip by roughly two pills in its direction.
   Buttons disable themselves when there's nothing to scroll that way. */
function getFilterScrollStep(pills) {
  return Math.max(480, Math.min(720, Math.round(pills.clientWidth * 0.65)));
}

function getNextVisibleFilterTarget(pills, dir) {
  const maxScroll = Math.max(0, pills.scrollWidth - pills.clientWidth);
  const currentLeft = pills.scrollLeft;
  const currentRight = currentLeft + pills.clientWidth;
  const pillsList = Array.from(pills.querySelectorAll('.f-pill'));
  const buffer = 3;

  if (dir > 0) {
    const next = pillsList.find(item => (item.offsetLeft + item.offsetWidth) > currentRight + buffer);
    if (!next) return maxScroll;

    // Move only far enough to fully reveal the next clipped/offscreen tile.
    return Math.min(maxScroll, Math.max(0, next.offsetLeft + next.offsetWidth - pills.clientWidth));
  }

  const prev = pillsList.slice().reverse().find(item => item.offsetLeft < currentLeft - buffer);
  if (!prev) return 0;

  // Move only far enough to fully reveal the previous clipped/offscreen tile.
  return Math.max(0, Math.min(maxScroll, prev.offsetLeft));
}

function scrollFilterPills(pills, dir) {
  const isMobile = window.matchMedia && window.matchMedia('(max-width: 700px)').matches;

  if (isMobile) {
    pills.scrollTo({ left: getNextVisibleFilterTarget(pills, dir), behavior: 'smooth' });
    return;
  }

  pills.scrollBy({ left: getFilterScrollStep(pills) * dir, behavior: 'smooth' });
}

['filter-scroll-prev', 'filter-scroll-next'].forEach(id => {
  const btn = document.getElementById(id);
  if (!btn) return;
  btn.addEventListener('click', () => {
    const pills = document.getElementById('filter-pills');
    if (!pills) return;
    const dir = btn.dataset.dir === 'left' ? -1 : 1;
    scrollFilterPills(pills, dir);
  });
});

// Sync each button's disabled state with current scroll position
function updateScrollBtn() {
  const pills = document.getElementById('filter-pills');
  const prev  = document.getElementById('filter-scroll-prev');
  const next  = document.getElementById('filter-scroll-next');
  if (!pills || !prev || !next) return;
  const overflows = pills.scrollWidth > pills.clientWidth + 1;
  const atStart   = pills.scrollLeft <= 4;
  const atEnd     = pills.scrollLeft + pills.clientWidth >= pills.scrollWidth - 4;
  prev.disabled = !overflows || atStart;
  next.disabled = !overflows || atEnd;
}

/* ── Boot: load Shopify-hosted reviews JSON ── */
async function boot() {
  const res = await fetch(window.REVIEWS_DATA_URL, { cache: 'no-cache' });
  DATA = await res.json();
  applyShopifyProductData();
  renderHeroStats();
  renderAll();
}
boot();
